import { render, staticRenderFns } from "./MonitoredAccounts.vue?vue&type=template&id=3949b966"
import script from "./MonitoredAccounts.vue?vue&type=script&lang=js"
export * from "./MonitoredAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports